import React, { Dispatch, SetStateAction } from 'react';

import { VisualSettings } from '@DStypes/chart';
import { MDBox } from '@components';

import TopOrBottomSlider from './TopOrBottomSlider';
// import FilterComponent from './FilterComponent';
// import FilterToggle from './FilterToggle';

interface Props {
  getSliderToolTip: () => string;
  renderSliderLabel: (value: number) => string;
  list: JSX.Element[];
  handleTopOrBottom: (value: boolean, field?: 'top' | 'bottom') => void;
  handleSelectAll: (value: boolean) => void;
  setSliderDrag: Dispatch<SetStateAction<boolean>>;
  preventClosing: any;
  topOrBottom: string;
  sliderValue: number;
  handleSliderChange: (value: number, topOrBottom: string) => void;
  sliderMarks: MarkType[];
  setShowFilter: Dispatch<SetStateAction<boolean>>;
  showFilter: boolean;
  xAxisField: any;
  dateSliderDisabled: boolean;
  getDateString: (index: number) => string;
  sliderRangeValue: number[];
  handleSliderRangeChange: (
    [min, max]: number[],
    isXAxisSelection?: boolean
  ) => void;
  setDateSliderDisabled: Dispatch<SetStateAction<boolean>>;
  xAxisLabelsExcluded: string[];
  autoGroupNumbers?: boolean;
  searchTextValue: string;
  setSearchTextValue: Dispatch<SetStateAction<string>>;
  height?: number;
  isDate: boolean;
  isDateTime: boolean;
  isXaxisNumber: boolean;
  visualSettings: VisualSettings | null;
  setVisualSettings: React.Dispatch<
    React.SetStateAction<VisualSettings | null>
  >;
  data: any[];
  disableFilter: boolean;
}

export interface MarkType {
  value: number;
  label: string;
}

const Filter: React.FC<Props> = ({
  data,
  handleSliderChange,
  handleTopOrBottom,
  isDate,
  isDateTime,
  isXaxisNumber,
  renderSliderLabel,
  setVisualSettings,
  sliderMarks,
  sliderValue,
  topOrBottom,
  visualSettings
  // autoGroupNumbers,
  // dateSliderDisabled,
  // disableFilter,
  // getDateString,
  // getSliderToolTip,
  // handleSelectAll,
  // handleSliderRangeChange,
  // list,
  // preventClosing,
  // searchTextValue,
  // setDateSliderDisabled,
  // setSearchTextValue,
  // setShowFilter,
  // setSliderDrag,
  // showFilter,
  // sliderRangeValue,
  // xAxisField,
  // xAxisLabelsExcluded
}) => (
  <MDBox marginBottom={2} maxHeight='max-content'>
    {TopOrBottomSlider({
      topOrBottom,
      isDate: Boolean(isDate || isDateTime),
      handleTopOrBottom,
      sliderValue,
      handleSliderChange,
      sliderMarks,
      renderSliderLabel,
      isDisabled: isDate || isDateTime || isXaxisNumber,
      visualSettings,
      setVisualSettings,
      dataLength: data?.length || 0
    })}

    {/* {FilterToggle({
      visualSettings,
      setVisualSettings,
      setShowFilter,
      preventClosing,
      disableFilter,
      showFilter
    })} */}

    {/* {showFilter && visualSettings?.filtersToggle && !disableFilter && (
      <FilterComponent
        xAxisField={xAxisField}
        getSliderToolTip={getSliderToolTip}
        isDate={Boolean(isDate || isDateTime)}
        topOrBottom={topOrBottom}
        dateSliderDisabled={dateSliderDisabled}
        getDateString={getDateString}
        sliderRangeValue={sliderRangeValue}
        sliderMarks={sliderMarks}
        handleSliderRangeChange={handleSliderRangeChange}
        setDateSliderDisabled={setDateSliderDisabled}
        setSliderDrag={setSliderDrag}
        renderSliderLabel={renderSliderLabel}
        xAxisLabelsExcluded={xAxisLabelsExcluded}
        autoGroupNumbers={autoGroupNumbers}
        handleSelectAll={handleSelectAll}
        searchTextValue={searchTextValue}
        setSearchTextValue={setSearchTextValue}
        list={list}
        isNumberSelf={isNumberSelf}
      />
    )} */}
  </MDBox>
);

export default Filter;
